import {ICartPosition, IPromotionalItem, PromotionalsFactory} from "@connox/typescript-library";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {getShopId} from "../../lib/getShopId";
import {useCartContext} from "../CartContextProvider/CartContextProvider";
import {ShadowBox} from "../ShoppingCart/ShadowBox";
import {ItemThumb} from "./ItemThumb";
import * as Sentry from "@sentry/browser";

let promotionItemsCache: IPromotionalItem[] = [];

const PromotionalItems: React.FC = () => {
  const {cart} = useCartContext();
  const [promoItems, setPromoItems] = React.useState<IPromotionalItem[] | null>(null);
  const promotionalItems = React.useRef<IPromotionalItem[]>([]);
  const {t} = useTranslation("cart");
  const itemPositions = cart.positions.filter((pos: ICartPosition) => pos.type === "Item");
  const mounted = React.useRef<boolean>(true);
  const removeItemsAlreadyIncludedInCart = (items: IPromotionalItem[]) => {
    return items.filter((candidate) => {
      return !itemPositions.find((position) => {
        return position.item && position.item.itemId === candidate.promotionalItems.itemId;
      });
    });
  };

  React.useEffect(() => {

    if(promotionItemsCache.length) {
      promotionalItems.current = promotionItemsCache;
      setPromoItems(removeItemsAlreadyIncludedInCart(promotionItemsCache));
    } else {
      PromotionalsFactory.retrievePromotionals(getShopId()).then((items) => {
        // if this happens, the component did unmount before the items where loaded
        if (!mounted.current) {
          return;
        }
        promotionItemsCache = items;
        promotionalItems.current = items;
        setPromoItems(removeItemsAlreadyIncludedInCart(items));
      }, Sentry.captureException);
    }

    return () => {
      mounted.current = false;
    };
  }, []);

  React.useEffect(() => {
    setPromoItems(removeItemsAlreadyIncludedInCart(promotionalItems.current));
  }, [cart.positions.length]);

  if (!promoItems || !promoItems.length) {
    return null;
  }

  return (
    <ShadowBox>
      {promoItems.map((promotionLine) => {
        const {images, itemId, title, url} = promotionLine.promotionalItems;
        const {formatted} = promotionLine.freeThreshold;

        return (
          <div key={itemId} className="ItemRow Promotional">
            <ItemThumb images={images} link={url} text={title} />
            <div className="ItemDetails">
              <p>
                <a className="Title-Link" href={url} title={t("{{title}} aufrufen", {title})}>
                  {title}
                </a>
                <br />
                {t("Ab {{formatted}} gratis dazu!", {formatted})}
              </p>
              <strong className="Right">{t("kostenlos")}</strong>
              <span className="Add-To-Cart" onClick={() => cart.addItem(itemId)}>
                {t("hinzufügen")}
              </span>
            </div>
          </div>
        );
      })}
    </ShadowBox>
  );
};

export default PromotionalItems;
